module.exports = __webpack_public_path__ + "static/shared-version-history.30db6b3a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/features/shared-version-history.jpg
// module id = 1000
// module chunks = 72138227098318